export default class Modal {
    constructor(containerId) {
        this.container = document.getElementById(containerId);
        if (this.container.getElementsByClassName("close-modal")[0]) {
            this.closeBtn = this.container.getElementsByClassName("close-modal")[0];
            this.addEvents();
        }
    }

    addEvents() {
        document.querySelectorAll(".close-modal").forEach((btn, index) => {
            btn.addEventListener("click", this.hide.bind(this), false);
        }, false);
    }

    hide() {
        if (document.getElementById("lnkTres"))
            window["lnkTres"].innerHTML="";
            
		document.body.classList.remove("no-scroll");
        TweenMax.to(this.container, 0.5, {
            ease: Power3.easeOut, 
            autoAlpha: 0
        });
            
    }

    show() {
		document.body.classList.add("no-scroll");
        
        TweenMax.to(this.container, 0.5, {
            ease: Power3.easeOut,
            display: "block",
            autoAlpha: 1,
            onComplete: () =>{
                 if (document.getElementById("modal-form"))
                     this.resize();
            }
        });
    }

    resize() {
            let _vhformulario = document.getElementById("contForm").getBoundingClientRect().height;
            let _vhimg = document.getElementById("viveVegrand");
            _vhimg.style.height = _vhformulario + "px";
            
            /* se actualice siempre */
            window.addEventListener("resize", () => {
                let _vhformulario = document.getElementById("contForm").getBoundingClientRect().height;
                let _vhimg = document.getElementById("viveVegrand");
                _vhimg.style.height = _vhformulario + "px";
            })

    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/modules/modal.js